/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface DurationWithOrigin
 */
export interface DurationWithOrigin {
    /**
     * 
     * @type {number}
     * @memberof DurationWithOrigin
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof DurationWithOrigin
     */
    unit: DurationWithOriginUnitEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DurationWithOrigin
     */
    fixed: boolean;
    /**
     * 
     * @type {Origin}
     * @memberof DurationWithOrigin
     */
    origin: Origin;
}


/**
 * @export
 */
export const DurationWithOriginUnitEnum = {
    Days: 'DAYS',
    Weeks: 'WEEKS',
    Months: 'MONTHS'
} as const;
export type DurationWithOriginUnitEnum = typeof DurationWithOriginUnitEnum[keyof typeof DurationWithOriginUnitEnum];


/**
 * Check if a given object implements the DurationWithOrigin interface.
 */
export function instanceOfDurationWithOrigin(value: object): value is DurationWithOrigin {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('fixed' in value) || value['fixed'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function DurationWithOriginFromJSON(json: any): DurationWithOrigin {
    return DurationWithOriginFromJSONTyped(json, false);
}

export function DurationWithOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): DurationWithOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'unit': json['unit'],
        'fixed': json['fixed'],
        'origin': OriginFromJSON(json['origin']),
    };
}

export function DurationWithOriginToJSON(value?: DurationWithOrigin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'unit': value['unit'],
        'fixed': value['fixed'],
        'origin': OriginToJSON(value['origin']),
    };
}

